import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-primary-500 tracking-widest uppercase mb-2" style={{ fontFamily: "var(--font-label)" }}>
            游戏分类
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            多元玩法，随心选择
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            必赢亚洲为您提供丰富多样的娱乐选择，总有一款适合您
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-xl p-6 md:p-8 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-primary-50 rounded-2xl flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {cat.description.slice(0, 60)}...
              </p>
              <span className="inline-flex items-center gap-1 mt-4 text-xs font-medium text-primary-500 group-hover:gap-2 transition-all duration-200 whitespace-nowrap">
                了解更多
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}